import _ from 'lodash';
import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';

import { UserService } from 'frilans-finans';
import { SpinnerButton, InputField, GeneralError } from 'components';

class EmailCapture extends React.Component {

  static propTypes = {
    // Redux state
    user: PropTypes.object
  };

  constructor (props) {
    super(props);

    let open = false;

    if (!_.isEmpty(this.props.user) && _.isEmpty(this.props.user.email)) {
      open = true;
    }

    this.state = {
      open: open,
      loading: false,
      showErrorWithoutBlur: false,
      email: { valid: false, value: '' },
      activateSubmitButton: false
    };

    this.callback = this.callback.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.user.email !== this.props.user.email) {
      if (!_.isEmpty(nextProps.user) && _.isEmpty(nextProps.user.email)) {
        this.setState({
          open: true
        });
      } else {
        this.setState({
          open: false
        });
      }
    }
  }

  callback (name, values) {
    this.setState({ email: values, activateSubmitButton: !!values.valid });
  }

  confirmationWithEmailGtmEvent (params) {
    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'emailConfirmation',
        'userData': {
          'email': params.email
        }
      });
    }
  }

  submit (e) {
    e.preventDefault();

    if (this.state.email.valid) {
      this.setState({loading: true});

      let params = { email: this.state.email.value };
      UserService.update(params)
      .then(() => {
        this.setState({
          loading: false,
          error: false
        });
        this.confirmationWithEmailGtmEvent(params);
      })
      .catch((error) => {
        let errors = UserService.getError(error);

        this.setState({
          loading: false,
          error: true,
          errorMessage: errors
        });
      });
    }
  }

  renderError () {
    if (this.state.error) {
      if (!this.state.errorMessage) {
        return (<GeneralError />);
      } else {
        return (
          <div>
            {this.state.errorMessage.map((error, i) => {
              return (
                <p className='error' key={i}>{error}</p>
              );
            })}
          </div>
        );
      }
    }
  }

  render () {
    return (
      <Modal
        className='modal-pop-complete-information'
        contentLabel=''
        isOpen={this.state.open}>
        <div className='modal-left-column'>
          <h2><Translate content='EMAIL_MODAL_TITLE'/></h2>
          <p><Translate content='EMAIL_MODAL_TEXT'/></p>
          <InputField
            type='text'
            inputMode='email'
            validationType='email'
            name='email'
            placeholder={proxyCounterpart('EMAIL')}
            callback={this.callback}
            required='true'
            minLength='3'
            errorMessage={proxyCounterpart('EMAIL_ERROR')}
            showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
             {this.renderError()}

          <div className='button-holder'>
            <SpinnerButton
              text={proxyCounterpart('SAVE')}
              loading={this.state.loading}
              classes='btn cover'
              callback={this.submit}
              disabled={!this.state.activateSubmitButton}
            />
          </div>
        </div>
        <div className='modal-right-column'>
          <img src={proxyCounterpart('EMAIL_MODAL_IMAGE')}/>
        </div>
      </Modal>
    );
  }
}

function mapStateToProps (state) {
  return {
    user: state.user
  };
};

export default connect(mapStateToProps)(EmailCapture);



/** WEBPACK FOOTER **
 ** ./src/components/bank-id/email-capture.js
 **/